export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.toLocaleString("default", {
    month: "long",
    day: "numeric",
    year: "numeric",
  })}`;
};

export const formatTime = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  })}`;
};

export const formatDateForAPI = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
